import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Crosshair, ArrowRight, ShieldCheck } from "lucide-react";
import { MEDIA } from "./media";

export function Hero({ deal, onClaim }) {
    const navigate = useNavigate();
    return (
        <section className="relative flex items-center overflow-hidden" data-testid="landing-hero">
            <div className="absolute inset-0">
                <img src={MEDIA.heroBg} alt="" aria-hidden className="w-full h-full object-cover opacity-40 scale-110 ww-kenburns" />
                <div className="absolute inset-0 bg-gradient-to-r from-obsidian via-obsidian/90 to-obsidian/40" />
                <div className="absolute inset-0 ww-grid [mask-image:radial-gradient(ellipse_at_center,black,transparent_75%)]" />
            </div>

            <div className="relative max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-12 items-center pt-16 pb-20 lg:py-28 w-full">
                <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-sm bg-volt/10 border border-volt/30 mb-5">
                        <Crosshair className="w-3.5 h-3.5 text-volt" />
                        <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-volt">Real-Time AI FPS Coach</span>
                    </div>
                    <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white leading-[1.05]">
                        Unfair Advantage,<br /><span className="text-volt">Delivered.</span>
                    </h1>
                    <p className="mt-5 text-base md:text-lg text-muted-foreground max-w-lg leading-relaxed">
                        WhiteWater AI watches your Warzone, Valorant, CS2 &amp; Apex gameplay and calls out enemies by the clock,
                        auto-clips your best moments, and reviews every match — like a pro coach in your ear.
                    </p>
                    <div className="mt-8 flex flex-wrap items-center gap-3">
                        <button onClick={() => navigate("/register")} data-testid="hero-cta-button"
                            className="h-12 px-7 bg-volt text-black font-bold uppercase tracking-wide rounded-sm hover:bg-[#33ceff] transition-colors flex items-center gap-2">
                            Start Free Trial <ArrowRight className="w-4 h-4" />
                        </button>
                        <button onClick={onClaim} data-testid="hero-claim-deal"
                            className="h-12 px-6 border border-white/20 text-white hover:border-volt rounded-sm transition-colors font-semibold">
                            {deal ? `Claim ${deal.percent_off}% Off` : "Today's Deal"}
                        </button>
                    </div>
                    <div className="mt-6 flex items-center gap-2 text-xs text-muted-foreground">
                        <ShieldCheck className="w-4 h-4 text-success" /> 7-day free trial · No anti-cheat risk · Cancel anytime
                    </div>
                </motion.div>

                <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7, delay: 0.15 }}
                    className="relative hidden lg:block">
                    <div className="relative rounded-sm border border-volt/30 overflow-hidden shadow-[0_0_60px_rgba(0,194,255,0.15)]">
                        <img src={MEDIA.hud} alt="WhiteWater AI tactical HUD overlay" className="w-full" />
                        <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
                    </div>
                    <motion.div animate={{ y: [0, -8, 0] }} transition={{ duration: 3, repeat: Infinity }}
                        className="absolute -left-6 top-10 bg-obsidian/90 backdrop-blur border border-volt/40 rounded-sm px-3 py-2 font-mono text-xs text-volt shadow-lg">
                        ▲ Enemy · 3 o'clock · close
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
}
